import { render, staticRenderFns } from "./ProductPanel.vue?vue&type=template&id=1a6f80ad&scoped=true&"
import script from "./ProductPanel.vue?vue&type=script&lang=js&"
export * from "./ProductPanel.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ProductPanel.vue?vue&type=style&index=0&id=1a6f80ad&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1a6f80ad",
  null
  ,true
)

export default component.exports